import { type_GM_STATE } from './../../helpers'

declare global {
  var GM_STATE: type_GM_STATE
  interface Window {
    SwymCallbacks?: Array<(swat: unknown) => void>
    SwymUtils?: unknown
    SwymWishlist?: unknown
    _swat?: unknown
    wishlistProvider?: {
      ready: boolean
    }
  }
}

const SWYM_READY_TIMEOUT_MS = 10000

function hasSwymRuntime() {
  return Boolean(window._swat)
}

function setWishlistProviderReady() {
  if (window.wishlistProvider) {
    window.wishlistProvider.ready = true
  }
}

function waitForSwymRuntime(timeoutMs = SWYM_READY_TIMEOUT_MS) {
  if (hasSwymRuntime()) {
    setWishlistProviderReady()
    return Promise.resolve()
  }

  return new Promise<void>((resolve, reject) => {
    const startedAt = Date.now()

    const poll = () => {
      if (hasSwymRuntime()) {
        setWishlistProviderReady()
        resolve()
        return
      }

      if (Date.now() - startedAt >= timeoutMs) {
        reject(new Error('Timed out waiting for Swym runtime to initialize'))
        return
      }

      window.setTimeout(poll, 50)
    }

    poll()
  })
}

async function initSwym() {
  window.SwymCallbacks = window.SwymCallbacks || []
  window.SwymCallbacks.push(() => {
    setWishlistProviderReady()
  })

  if (hasSwymRuntime()) {
    setWishlistProviderReady()
    return true
  }

  try {
    await waitForSwymRuntime()
    return true
  } catch (error) {
    console.warn('Swym runtime did not initialize in time', error)
    return false
  }
}

export const initWishlistProvider = async () => {
  const wishlistProviderState: NonNullable<Window['wishlistProvider']> = {
    ready: false
  }
  window.wishlistProvider = wishlistProviderState

  const isSwymReady = await initSwym()
  wishlistProviderState.ready = isSwymReady
  return isSwymReady
}